var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.footerComponent && _vm.hasData)?_c(_vm.footerComponent,{tag:"component",attrs:{"items":_vm.footer_details.item,"desktop_icon_group":_vm.footer_details.desktop_icon_group,"mobile_icon_group":_vm.footer_details.mobile_icon_group}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }